import { CustomBox } from 'components/Box/CustomBox'
import React from 'react'
import DescriptionIcon from '@material-ui/icons/Description';
import { fontSize, iconStyle } from '../CustomerView';
import RegularButton from 'components/CustomButtons/Button';
import {  useSelector } from 'react-redux';
import { useHandleView } from '../useHandleView';

export const CustomerDocs= () => {
  const { contracts } = useSelector(({customersReducer}) => customersReducer)
  const selectView = useHandleView(7)

  return (
    <CustomBox
    title="Documentación"
    count={contracts?.length}
    icon={<DescriptionIcon style={iconStyle} />}
    bg={<DescriptionIcon style={{ ...iconStyle, fontSize }} />}
  >
     <RegularButton
          size="sm"
          color="info"
          fullWidth
          onClick={selectView}
        >
        Ver
        </RegularButton>
  </CustomBox>
  )
}
